export default {
  badge: 'باج',
  open: 'کردنەوە',
  close: 'داخستن',
  dismiss: 'ڕەتکردنەوە',
  confirmEdit: {
    ok: 'باشە',
    cancel: 'هەڵوەشاندنەوە',
  },
  dataIterator: {
    noResultsText: 'هیچ تۆمارێکی هاوتا نەدۆزرایەوە',
    loadingText: 'بارکردنی ئایتمەکان...',
  },
  dataTable: {
    itemsPerPageText: 'ڕیزەکان بۆ هەر پەڕەیەک:',
    ariaLabel: {
      sortDescending: '.سەر بەرەو خوار ڕیزکراوە',
      sortAscending: '.سەر بەرەو ژوور ڕیزکراوە',
      sortNone: 'ڕیزنەکراوە.',
      activateNone: 'چالاککردن بۆ لابردنی ڕیزکردن.',
      activateDescending: 'چالاککردن بۆ ڕیزکردنی سەربەرەوخوار.',
      activateAscending: 'چالاککردن بۆ ڕیزکردنی سەر بەرەو ژوور.',
    },
    sortBy: 'ڕیزکردن بەپێی',
  },
  dataFooter: {
    itemsPerPageText: 'ئایتمەکان بۆ هەر پەڕەیەک:',
    itemsPerPageAll: 'هەمووی',
    nextPage: 'پەڕەی دواتر',
    prevPage: 'پەڕەی پێشوو',
    firstPage: 'پەڕەی یەکەم',
    lastPage: 'پەڕەی کۆتایی',
    pageText: '{0}-{1} لە {2}',
  },
  dateRangeInput: {
    divider: 'بۆ',
  },
  datePicker: {
    itemsSelected: '{0} هەڵبژێردراوە',
    range: {
      title: 'بژاردنی بەروارەکان',
      header: 'بەروارەکان بنووسە',
    },
    title: 'بژاردنی بەروار',
    header: 'بەروار بنووسە',
    input: {
      placeholder: 'بەروار بنووسە',
    },
    ariaLabel: {
      previousMonth: 'مانگی پێشوو',
      nextMonth: 'مانگی داهاتوو',
      selectYear: 'ساڵ هەڵبژێرە',
      selectDate: '{0}',
      currentDate: 'ئەمڕو، {0}',
    },
  },
  noDataText: 'هیچ داتایەک بەردەست نیە',
  carousel: {
    prev: 'بینراوی پێشوو',
    next: 'بینراوی داهاتوو',
    ariaLabel: {
      delimiter: 'سلایدی کارۆسێل {0} لە {1}',
    },
  },
  calendar: {
    moreEvents: '{0} زیاتر',
    today: 'ئەمڕو',
  },
  input: {
    clear: 'سڕینەوە {0}',
    prependAction: '{0} کرداری پێشەوە',
    appendAction: '{0} کرداری دواتر',
    otp: 'تکایە نووسینی نمرەی OTP {0}',
  },
  fileInput: {
    counter: '{0} فایل',
    counterSize: '{0} فایل ({1} لە کۆی گشتی)',
  },
  fileUpload: {
    title: 'فایلەکان بکشە و دابنێ لێرە',
    divider: 'یان',
    browse: 'گەڕان بۆ فایلەکان',
  },
  timePicker: {
    am: 'پێش نیوەڕۆژ',
    pm: 'دوای نیوەڕۆژ',
    title: 'کات دیاریبکە',
  },
  pagination: {
    ariaLabel: {
      root: 'ڕێنیشاندەری پەڕەگۆڕکێ',
      next: 'پەڕەی دواتر',
      previous: 'پەڕەی پێشوو',
      page: 'بڕۆ بۆ پەڕەی {0}',
      currentPage: 'پەڕەی ئێستا، پەڕە {0}',
      first: 'پەڕەی یەکەم',
      last: 'پەڕەی کۆتایی',
    },
  },
  stepper: {
    next: 'داهاتوو',
    prev: 'پێشوو',
  },
  rating: {
    ariaLabel: {
      item: 'هەڵسەنگاندن {0} لە {1}',
    },
  },
  loading: 'بارکردن...',
  infiniteScroll: {
    loadMore: 'زیاتر باربکە',
    empty: 'هیچتر نیە',
  },
  rules: {
    required: 'ئەم خانە پێویستە',
    email: 'تکایە ئیمەیڵێکی دروست بنووسە',
    number: 'ئەم خانە تەنها دەتوانێت ژمارەکان بگرێت',
    integer: 'ئەم خانە تەنها دەتوانێت نرخی تەواو بگرێت',
    capital: 'ئەم خانە تەنها دەتوانێت پیتە گەورەکان بگرێت',
    maxLength: 'پێویستە زۆرترین {0} پیت بنووسیت',
    minLength: 'پێویستە کەمترین {0} پیت بنووسیت',
    strictLength: 'درێژیی خانەی نووسراو نادروستە',
    exclude: 'پیتەکەی {0} ڕێپێدراو نیە',
    notEmpty: 'تکایە بەلایەنی کەم یەک هەڵبژێرە',
    pattern: 'فۆرماتەکە نادروستە',
  },
  hotkey: {
    then: 'پاشان',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'تیری سەرەوە',
    downArrow: 'تیری خوارەوە',
    leftArrow: 'تیری چەپ',
    rightArrow: 'تیری ڕاست',
    backspace: 'Backspace',
    space: 'بۆشایی',
    plus: 'زیادکردن',
    shortcut: 'کورتەبڕی تەختەکلیل: {0}',
  },
  video: {
    play: 'لێدان',
    pause: 'ڕاگرتن',
    seek: 'گەڕان',
    volume: 'دەنگ',
    showVolume: 'پیشاندانی کۆنترۆڵی دەنگ',
    mute: 'بێدەنگکردن',
    unmute: 'لە بێدەنگی دەرهێنان',
    enterFullscreen: 'پڕ بە شاشە',
    exitFullscreen: 'چوونە دەرەوە لە پڕ بە شاشە',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'ڕەنگ لەسەر شاشە هەڵبژێرە',
      hueSlider: 'ڕەنگ',
      alphaSlider: 'ئەلفا',
      redInput: 'سوور',
      greenInput: 'سەوز',
      blueInput: 'شین',
      alphaInput: 'ئەلفا',
      hueInput: 'ڕەنگ',
      saturationInput: 'تێربوون',
      lightnessInput: 'کاڵی',
      hexInput: 'بەهای HEX',
      hexaInput: 'HEX لەگەڵ بەهای ئەلفا',
      changeFormat: 'گۆڕینی فۆرماتی ڕەنگ',
    },
  },
}
